// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomView.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';

class CustomViewModel {
  @observable databases = [];
  @observable schemas = [];
  @observable viewName = null;
  @observable databaseId = null;
  @observable databaseName = null;
  @observable schemaId = null;
  @observable schemaName = null;
  @observable query = '';
  isLastPageDatabase = false;
  isLastPageSchema = false;
  id = null;

  constructor(item = {}) {
    this.id = item.id;
    this.viewName = item.realName;
    this.databaseId = item.connectionId;
    this.databaseName = item.connectionName;
    this.schemaId = item.categoryId;
    this.schemaName = item.querySourceCategoryName;
    this.query = item.customDefinition;
  }

  @action
  updateViewName = ({ target: { value: name } }) => {
    this.viewName = name;
  };

  @action
  setDatabase = (id, name) => {
    this.databaseId = id;
    this.databaseName = name;
    this.schemaId = null;
    this.schemaName = null;
    this.schemas = [];
  };

  @action
  setSchema = (id, name) => {
    this.schemaId = id;
    this.schemaName = name;
  };

  @action
  updateQuery = ({ target: { value: query } }) => {
    this.query = query;
  };
}

export default CustomViewModel;



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.CustomView.js